import { FormEvent, useEffect, useState } from "react";
import { CreateVideoInput, VideoProps } from "../store/actionType";
import { ThumbnailForm } from "./components/ThumbnailForm";
import { updateVideoDetail } from "../store/action";
import { connect, useSelector } from "react-redux";

interface OwnProps {
  videoDetails: VideoProps;
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleUploadThumbnail: React.FC<Props> = ({
  videoDetails,
  onUpdateVideo,
  closeModal,
}) => {
  const videoDetailsState = useSelector(
    (state: any) => state.videoDetails?.genericVideoDetailsState
  );
  const [thumbnailFile, setThumbnailFile] = useState<File | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [apiError, setApiError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    if (!thumbnailFile) {
      setError("Please select a thumbnail file to upload.");
      return;
    }
    let uploadedFilename: string | undefined = undefined;
    if (thumbnailFile) {
      const uploadUrl = `${process.env.REACT_APP_THUMBNAIL_UPLOAD_BASE_URL}`;
      const form = new FormData();
      form.append("file", thumbnailFile);
      const response = await fetch(uploadUrl ?? "", {
        method: "POST",
        body: form,
      });
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Upload failed:", errorText);
        throw new Error("Failed to upload image");
      }
      const result = await response.json();
      uploadedFilename = result?.imagePath;

      if (!uploadedFilename) {
        console.error("Image upload response invalid", result);
        throw new Error("Image upload response invalid");
      }
    }
    const input: CreateVideoInput = {
      title: videoDetails?.video?.title,
      episode_id: videoDetails?.video.episode?.id?.toString(),
      category_id: videoDetails?.video.category?.id?.toString(),
      season_folder_id: videoDetails?.video.season_folder_id.toString(),
    };
    if (uploadedFilename) {
      input.thumbnail = uploadedFilename;
    }

    setError("");
    setApiError(null);
    setSubmitted(true);
    setLoading(true);
    onUpdateVideo(input, videoDetails.video.id.toString());
  };
  useEffect(() => {
    if (!videoDetailsState.isLoading && submitted) {
      if (videoDetailsState.error) {
        setApiError(videoDetailsState.error); // show error
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [videoDetailsState.isLoading, videoDetailsState.error, submitted]);
  return (
    <>
      <ThumbnailForm
        loading={loading}
        header={"Upload Video Thumbnail"}
        handleThumbnailFileChange={setThumbnailFile}
        handleSubmit={handleSave}
        errorMessage={error}
        thumbnailUrl={videoDetails?.video?.thumbnail}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdateVideo: (input: CreateVideoInput, video_id: string) =>
    dispatch(updateVideoDetail(input, video_id)),
});

export default connect(null, mapDispatchToProps)(HandleUploadThumbnail);
